module.exports = __webpack_public_path__ + "static/img/3.743b652.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/3/eng/3.png
// module id = eVM9
// module chunks = 0